<template>
  <div class="x-tablelist-view" data-automation="keyList">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @change="change"
      @input="seach"
      @search="seach"
      @add="showAdd"
      @addThird="showAddThird"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :emptyText="$t('HT.nodata')"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addUser from './template/addUser';
import joinUserGroup from './template/joinUserGroup';
import amsRelation from './template/amsRelation';
let userData;
export default {
  data() {
    userData = this.$store.state.login.userData;
    return {
      layout: [
        // 搜索项配置

        {
          //只是主账号的话就没必要显示了
          type: 'select',
          options:
            userData.owner && userData.supervisor
              ? [
                {
                  label: this.$t('HT.userList.text1'),
                  value: ''
                },
                {
                  label: this.$t('HT.userList.text2'),
                  value: true
                }
              ]
              : [
                {
                  label: this.$t('HT.userList.text1'),
                  value: ''
                }
              ],
          key: 'owner',
          placeholder: this.$t('HT.userList.text3'),
          hidden: !userData.owner ? true : false,
          width: '150px',
          event: 'change'
        },
        {
          type: 'input',
          key: 'keyword',
          placeholder: this.$t('HT.pleaseInput')
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.userInfo.add'),
          right: true,
          hidden: userData.supervisor ? !this.$hasModule(27) : true,
          event: 'add'
        },
        {
          // 添加三级用户复用新增用户弹窗
          type: 'button',
          text: this.$t('HT.userInfo.addThirdLevel'),
          hidden: userData.owner ? false : true,
          event: 'addThird',
          // 添加用户按钮隐藏时，由当前按钮将按钮组推到最右侧
          right: userData.supervisor ? !this.$hasModule(27) : true
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addUser.user'),
          tooltip: true,
          minWidth: 215,
          align: 'left',
          // align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {},
              params.parent_name
                ? params.parent_name + ` / ${params.username}`
                : `${params.username}`
            );
          }
        },
        {
          label: this.$t('HT.addUser.nickname'),
          prop: 'nickname',
          minWidth: 140,
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.addUser.phone'),
          minWidth: 130,
          prop: 'phone',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          label: this.$t('HT.addUser.email'),
          minWidth: 100,
          prop: 'email',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue || '--';
          }
        },
        {
          // 账号总配额，单位为万次
          label: this.$t('HT.userList.totalQuota'),
          minWidth: 120,
          prop: 'total_quota',
          align: 'left',
          tooltip: true
        },
        {
          // 账号已使用配额，单位为万次
          label: this.$t('HT.userList.usedQuota'),
          minWidth: 120,
          prop: 'used_quota',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.personal.text3'),
          minWidth: 130,
          prop: 'owner',
          align: 'left',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return cellValue ? this.$t('HT.personal.text4') : this.$t('HT.personal.text5');
          }
        },
        {
          label: this.$t('HT.router.userListGroup'),
          minWidth: 100,
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: params.group_list.map((item) => item.group_name),
                colors: ['#5a6482'],
                isSpan: true
              }
            });
          }
        },

        {
          label: this.$t('HT.operation'),
          minWidth: 120,
          hidden: !this.$hasModule(27),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [
                  this.$t('HT.userList.text4'),
                  this.$t('HT.addChannel.close'),
                  this.$t('HT.addChannel.open')
                ],
                className: [
                  '',
                  !params.disabled ? 'no-click' : '',
                  params.disabled ? 'no-click' : ''
                ],
                colors: ['#0087ff', '#f45c5c', '#0087ff'],
                event: ['toRelation', 'toDisable', 'toStart']
              },
              on: {
                toRelation: () => {
                  this.getCustomerCode(params);
                  this.relation(params);
                },
                toDisable: () => {
                  this.forDisable(params);
                },
                toStart: () => {
                  this.forDisable(params);
                }
              }
            });
          }
        }
      ],
      cusData: '',
      filter: {
        // 查询参数
        owner: '', // 账号类型
        keyword: '', // 名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      ownerArr: [], //保存所有主账号
      groupList: [] //保存当前登录对象的用户组信息
    };
  },
  created() {
    this.getList(this.filter);
    this.loginGroup();
  },
  methods: {
    // 获取AMS客户信息
    getCustomerCode(params) {
      this.$api.system.getCustomerCode(params.id).then((res) => {
        if (res.code == 10000) {
          this.cusData = res.data;
        }
      });
    },
    // 修改AMS客户信息
    amsRelation(data, params) {
      const dataObj = {
        code: data.code,
        account_id: params.id
      };
      this.$api.system.addCustomerCode(dataObj).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.userList.text5')); // success/warning/error
          this.getList(this.filter);
        }
      });
    },
    // AMS关联
    relation(params) {
      const title = this.$t('HT.userList.ams');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(amsRelation, {
            props: {
              data: {
                code: this.cusData?.code
              }
            }
          });
        },
        confirm: (data) => {
          this.amsRelation(data, params);
        }
      });
    },

    /**
     * 选择账号分组
     */
    change(isChecked) {
      // 显示主账号
      if (isChecked) {
        // this.tableData = {
        //     totalSize: this.ownerArr.length,
        //     list: this.ownerArr
        // };
        this.getList(this.filter);
      } else {
        // 显示所有账号
        this.filter.page = 1;
        // this.filter.size = ;
        this.getList(this.filter);
      }
    },
    /**
     * 方法
     * @param {Object} params 查询对象
     */
    forDisable(params) {
      this.$api.system.disableAndstart(params.id, { disabled: !params.disabled }).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          params.disabled === true
            ? this.$uxMessage.success(this.$t('HT.addApi.disabledSuccess'))
            : this.$uxMessage.success(this.$t('HT.addApi.enabledSuccess'));
          this.getList(this.filter);
        }
      });
    },

    // 加入用户组弹窗
    joinUserGroup() {
      const title = this.$t('HT.userList.join');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(joinUserGroup, {
            on: {}
          });
        },
        confirm: (data) => {
          this.addUsergroup(data);
        }
      });
    },
    /**
     * 方法
     * @param {Array} idArr 请求参数
     */
    addUsergroup(idArr) {
      this.$api.system.setGroup(idArr).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.user.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.owner = '';
      this.filter.keyword = '';
      this.seach();
    },
    /**
     * 方法
     */
    loginGroup() {
      this.groupList = userData.groups.map((item) => {
        return {
          label: item.group_name,
          value: item.id
        };
      });
    },
    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     * @param {String} api 新增账号使用的接口方法
     */
    addList(params, api) {
      this.$uxLoading.show();
      this.$api.user[api](params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.user.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     * @param {String} api 新增账号使用的接口方法
     * @param {Boolean} showOwner 是否选择所属二级账号
     */
    showAdd(api = 'addList1', showOwner = false) {
      const title = this.$t('HT.userInfo.addAccount');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addUser, {
            props: {
              list: this.groupList, //非超级管理员的主账号用户组信息传递给弹窗
              showOwner
            }
          });
        },
        confirm: (data) => {
          const nocheckData = JSON.parse(JSON.stringify(data));
          if (userData.supervisor) {
            // 数字转换成数组
            nocheckData.group_ids = Array.of(nocheckData.group_ids);
            nocheckData.space_id = userData.space_id;
            // 非超管主账号
          } else {
            let valArr = [];
            for (let item of this.groupList) {
              valArr.push(item.value);
            }
            nocheckData.group_ids = valArr;
            nocheckData.space_id = nocheckData.parent_id;
          }
          this.addList(nocheckData, api);
        }
      });
    },

    /**
     * 打开添加三级用户弹窗
     */
    showAddThird() {
      this.showAdd('addList2', true);
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
